export default "__VITE_ASSET__9ba092aa__"